export { default as FooterCompact } from './FooterCompact'
export type * from './FooterCompact'
export { default as HeaderCompact } from './HeaderCompact'
export type * from './HeaderCompact'
export { default as Footer, LocaleSwitchLink, FooterMobileSectionContent, FooterDesktopSectionContent } from './Footer'
export type { FooterProps, FooterText, Section } from './Footer'

export { default as Header } from './Header'
export type * from './Header'
export {
  default as UserInfo,
  UserLoginLink,
  UserInfoLoading,
  type UserInfoProps,
  type UserLoginLinkProps,
} from './UserInfo'
